import {
  GET_VEHICLE_TYPES_FAIL,
  GET_VEHICLE_TYPES_SUCCESS,
  GET_VEHICLE_TYPES_REQUEST,
} from "../constants/vehicleConstants";
import axios from "axios";
import baseUrl from "../constants/baseUrl";
import * as Sentry from "@sentry/react";

// vehicle types action
// this action is called in multiple pages
// it shows vehicle and its types
export const getAllVehicles = () => async (dispatch) => {
  try {
    dispatch({
      type: GET_VEHICLE_TYPES_REQUEST,
    });
    const { data } = await axios.get(`${baseUrl}VehicleTypesAPI`);
    console.log("vehicle data from api", data);
    dispatch({
      type: GET_VEHICLE_TYPES_SUCCESS,
      payload: data,
    });
  } catch (error) {
    Sentry.captureException(error);
    console.log(error);
    dispatch({
      type: GET_VEHICLE_TYPES_FAIL,
      payload: "vehicle types API Failed,Please try again!",
    });
  }
};

// single vehicle action
// this action is called in multiple pages
// it shows vehicle specs
export const getSingleVehicle = (vehicleId) => async (dispatch) => {
  try {
    dispatch({
      type: GET_VEHICLE_TYPES_REQUEST,
    });
    const { data } = await axios.get(`${baseUrl}VehicleTypesAPI/${vehicleId}`);
    console.log("vehicle data from api", data);
    dispatch({
      type: GET_VEHICLE_TYPES_SUCCESS,
      payload: data,
    });
  } catch (error) {
    Sentry.captureException(error);
    console.log(error);
    dispatch({
      type: GET_VEHICLE_TYPES_FAIL,
      payload: "vehicle types API Failed,Please try again!",
    });
  }
};

export const suggestedVehicleAndLabour = async (
  isTruckRequired,
  items,
  locationData = {}
) => {
  const vehiclePayload = {
    analyzeItems: items,
    isTruckRequired,
    visionId: Number(localStorage.getItem("visionReqId")),
  };

  const labourPayload = {
    items: items.map((item) => ({
      name: item.name,
      size: item.size || "medium",
      qty: item.quantity?.toString() || "1",
      refId: Number(item.referenceId) || 0,
      isDisassembleRequired: item.isDisassembleRequired || false,
    })),
    pickupAccess: locationData.pickupMedium || "Ground Floor",
    dropoffAccess: locationData.dropoffMedium || "Ground Floor",
    totalDistanceKm: locationData.distance || 0,
  };

  const [vehicleRes, labourRes] = await Promise.allSettled([
    axios.post(`${baseUrl}VisionBookingAPI/SuggestedVehicle`, vehiclePayload),
    axios.post(`${baseUrl}VisionBookingAPI/SuggestedLabour`, labourPayload),
  ]);

  return {
    vehicleResult:
      vehicleRes.status === "fulfilled" ? vehicleRes.value.data : null,
    labourResult:
      labourRes.status === "fulfilled" ? labourRes.value.data : null,
  };
};
